import Image from "next/image";

const renderBlock = ({ imgUrl, imgWidth, imgHeight, imgAlt, number, text }) => {
  return (
    <div className="col">
      <Image
        style={{ display: "inline" }}
        src={imgUrl}
        alt={imgAlt}
        width={imgWidth}
        height={imgHeight}
      />
      <h3 className="heading heading--xxl">{number}</h3>
      <h6 className="body body--lg">{text}</h6>
    </div>
  );
};

const JoinANetwork = ({ head, block1, block2, block3 }) => {
  return (
    <section className="join-a-network full">
      <div className="join-a-network__banner banner">
        <div className="join-a-network__copy">
          <div className="section-header">
            <h2 className="heading heading--lg"> {head} </h2>
          </div>
          <div className="three-col">
            <div>{renderBlock(block1)}</div>
            <div>{renderBlock(block2)}</div>
            <div>{renderBlock(block3)}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JoinANetwork;
